module.exports = __webpack_public_path__ + "img/mockAi.859de0e8.svg";